(function () {

    'use strict';

    function pxAssignedNetworks(
        $timeout, $window, NetworkListService
    ) {
        return {
            restrict: 'E',
            scope: {
                dialogTitle: '=',
                dialogIconClass: '=',
                networkIds: '=',
                onCloseDialog: '&'
            },
            templateUrl: 'app/components/settings/snmpConfigurations/assignedNetworks.template.html',
            link: function (scope, element, attrs) {

                scope.networks = null;

                scope.closeDialog = function () {
                    scope.onCloseDialog();
                };

                scope.navigateToNetworksPage = function () {
                    $window.open('/admin/#/networks/');
                };

                (function () {
                    centerDialog();
                    getNetworks();
                })();

                function centerDialog() {
                    $timeout(function () {
                        const dialogElement = angular.element('.context-content-container');
                        const dialogLeft = ($window.innerWidth - dialogElement.innerWidth()) / 2;
                        const dialogTop = ($window.innerHeight - dialogElement.innerHeight()) / 2;
                        dialogElement.css({ left: dialogLeft, top: dialogTop, display: 'block' });
                    }, 100);
                }

                function getNetworks() {
                    NetworkListService.getNetworksByIds(scope.networkIds).then(function (response) {
                        scope.networks = response.data.sort((a, b) => a.name.localeCompare(b.name));
                    }).catch(function(error){
                        console.error(`NetworkListService.getNetworksByIds() failed with error code ${response.status}.`);
                    });
                }
            }
        };
    }

    pxAssignedNetworks.$inject = ['$timeout', '$window', 'NetworkListService'];

    angular
        .module('printix-admin')
        .directive('pxAssignedNetworks', pxAssignedNetworks);

})();
